







































































import Vue from 'vue'
import Slider from '@/components/ui/Slider.vue'
import TagChooser from '@/components/ui/TagChooser.vue'
import { Resource } from '@/lib/types'
import api from '@/lib/api';
export default Vue.extend({
    components: { Slider, TagChooser },
    data(){
        return {
            resource: undefined as Resource | undefined,
            selected_file: undefined as undefined | File,
            selected_category: '',
            categories: [] as any[],
            thumbnail: undefined as undefined | File,
            by_tag: false,
            tags: [] as string[],
            pipes: {
                'white': [],
                'bronze': [],
                'silver': [],
                'gold': [],
                'platinum': []
            } as { [key: string]: Array<{ event: 'delete', id: string }> }
        }
    },  
    async mounted(){
        const response = await api.media.categories.getAllCategoryNames();
        if(response.err){
            return alert("di' a cippi che è successo un casino");
        }
        this.categories = response.ok!.value;

        const tag_response = await api.media.tags.search('');
        if(tag_response.err) return alert("di' a cippi che è successo un casino");
        
        this.tags = tag_response.ok!.value;

    },
    methods: {
        notifyDeletion(id: string, from: 'white' | 'bronze' | 'silver' | 'gold' | 'platinum'){
            
            Object.keys(this.pipes).forEach(pipe => {
                if(pipe !== from) this.pipes[pipe].push({ event: 'delete', id })
            })

        },
        closeModal(){
            this.thumbnail = undefined;
            this.resource = undefined;
            this.selected_file = undefined;
            this.selected_category = '';
        },
        updateTags(tags: Set<string>){
            if(this.resource){
                console.log(tags);
                this.resource.tags = Array.from(tags) as string[];
            }
        },
        async editResource(){

            if(this.resource){
                const edit_response = await api.media.resources.editResource(this.resource);
                if(edit_response.err) return alert("di' a cippi che è successo un casino");
            }
            if(this.selected_file && this.resource?.type === 'pdf'){
                const url = await api.media.articles.getSignedUrl();
                if(url.err){
                    alert("di' a cippi che è successo un casino");
                    return null;
                }

                await fetch(url.ok!.value.url, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    body: this.selected_file
                });

            }

            if(this.thumbnail){

                const stuff = await api.media.resources.getSignedUrl();
                if(stuff.err) return alert("di' a cippi che è successo un casino");

                await fetch(stuff.ok!.value.signed_url, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    body: this.thumbnail
                });

                await api.media.resources.setThumbnail(this.resource!.id.toString(), stuff.ok!.value.filename);

            }

            this.resource = undefined;
            location.reload();

        },
        loadFile(){
            document.getElementById('pdf')!.click();
        },
        loadThumbnail(){
            document.getElementById('tfile')!.click();
        },
        modal(resource: Resource){
            this.resource = resource;
        },
        toggleResourceType(type: 'pdf' | 'link'){
            this.resource!.type = type;
        },
        setFile(){
            const input = document.getElementById('pdf')! as HTMLInputElement;
            if(!input.files) return;

            this.selected_file = input.files[0];
        },
        setThumbnail(){
            const input = document.getElementById('tfile')! as HTMLInputElement;
            if(!input.files) return;

            this.thumbnail = input.files[0];
        }
    }
})
